import React from 'react';

import '../../stylesheets/normalize.css';
import '../../stylesheets/general.css';

import '@fortawesome/fontawesome-svg-core/styles.css';

import { library, config } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faBook,
  faCalendar,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCity,
  faExternalLinkAlt,
  faImages,
  faInfoCircle,
  faMap,
  faTimes,
  faUniversity,
  faUserGraduate,
  faUtensils,
  faShareSquare,
} from '@fortawesome/free-solid-svg-icons';

import { fab, faInstagram, faLinkedin, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import ExplorerTemplate from '../../templates/ExplorerTemplate';
import { isIE } from '../../utils/functions';
import { Container, Content } from './styles';

config.autoAddCss = false;
library.add(
  faShareSquare,
  fab,
  faBars,
  faBook,
  faCalendar,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCity,
  faExternalLinkAlt,
  faImages,
  faInfoCircle,
  faInstagram,
  faLinkedin,
  faMap,
  faTimes,
  faTwitter,
  faUniversity,
  faUserGraduate,
  faUtensils,
  faYoutube,
);

const Layout = ({ children }) => {
  const renderContent = () => (
    <Container>
      <Content>{children}</Content>
    </Container>
  );

  return <>{isIE() ? <ExplorerTemplate /> : renderContent()}</>;
};

export default Layout;
